import BaseService from "./BaseService";

export default class ClientService extends BaseService {
  endPoint = "Clients";

  constructor(keycloakToken, currentScope = "") {
    super(keycloakToken, currentScope);
  }

  async GetFromUser() {
    return this.get(`${this.endPoint}/GetCurrentUserClients`);
  }
}
